import { Controller } from '@hotwired/stimulus'

const BOTTOM_TOLERANCE = 32
const REAPPEAR_DELAY = 2500
const SCROLL_RATIO = 0.8

export default class extends Controller {
  static targets = ['button']

  connect() {
    this.update = this.update.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.element.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.update)

    if (window.ResizeObserver && this.element.firstElementChild) {
      this.resizeObserver = new ResizeObserver(this.update)
      this.resizeObserver.observe(this.element.firstElementChild)
    }

    this.update()
  }

  disconnect() {
    this.element.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.update)
    clearTimeout(this.reappearTimer)
    if (this.resizeObserver) this.resizeObserver.disconnect()
    this.resizeObserver = null
  }

  onScroll() {
    this.toggle(false)
    clearTimeout(this.reappearTimer)
    this.reappearTimer = setTimeout(this.update, REAPPEAR_DELAY)
  }

  update() {
    const { scrollHeight, scrollTop, clientHeight } = this.element

    this.toggle(scrollHeight - scrollTop - clientHeight > BOTTOM_TOLERANCE)
  }

  toggle(visible) {
    if (this.hasButtonTarget) this.buttonTarget.hidden = !visible
  }

  scrollDown() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    this.element.scrollBy({
      top: this.element.clientHeight * SCROLL_RATIO,
      behavior: reduceMotion ? 'auto' : 'smooth'
    })
  }
}
